import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable } from 'rxjs';
import { CreateCalibration } from 'app/dtos/calibration/createCalibration';
import { UpdateCalibration } from 'app/dtos/calibration/updateCalibration';

@Injectable({
  providedIn: 'root'
})
export class CalibrationService {

  constructor(private httpClientService: HttpClientService) { }

  async getAllCalibrations(page, size, startDate?: string, endDate?: string, companyId?: number, accreditationOgranization?: number,status?:number) {
    const queryParams = new URLSearchParams();

    queryParams.append("Page", page.toString());
    queryParams.append("Size", size.toString());

    if (startDate !== null && startDate !== undefined) queryParams.append("StartDate", startDate);
    if (endDate !== null && endDate !== undefined) queryParams.append("EndDate", endDate);
    if (companyId !== null && companyId !== undefined) queryParams.append("CompanyId", companyId.toString());
    if (status !== null && status !== undefined) queryParams.append("Status", status.toString());
    if (accreditationOgranization !== null && accreditationOgranization !== undefined) {
      queryParams.append("AccreditationOgranization", accreditationOgranization.toString());
    }
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Calibration,
      queryString: queryParams.toString()
    });
    return await firstValueFrom(observable);
  }

  async getByIdCalibration(id) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Calibration
    }, id);
    return await firstValueFrom(observable);
  }

  async getByIdReadyCalibration(id){
    const observable:Observable<any> = this.httpClientService.get({
      controller:ControllerType.Calibration,
      action:"GetByIdReadyCalibration"
    },id);
    return await firstValueFrom(observable);
  }

  async createCalibration(createCalibration: CreateCalibration) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.Calibration,
    }, createCalibration);
    return await firstValueFrom(observable);
  }

  async updateCalibration(updateCalibration: UpdateCalibration) {
    const observable: Observable<any> = this.httpClientService.put({
      controller: ControllerType.Calibration
    }, updateCalibration);
    return await firstValueFrom(observable);
  }

  async updateCalibrationStatus(id, status) {
    const urlParameter = `${id}/${status}`;
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.Calibration,
      action: "UpdateCalibrationStatus",
      queryString: `/${status}`
    }, urlParameter);
    return await firstValueFrom(observable);
  }
}
